<template>
  <div>
    <div class="text-right">
      <base-button @click="doExport" type="primary" size="lg" class="btn-fill text-right">
        Export Evaluation
      </base-button>
    </div>
    <div class="full-overlay d-flex" v-if="exporting">
      <div class="mx-auto mt-5">
        <h3 class="mb-2">Please wait, generating export...</h3>
        <h4>It could take a few minutes.</h4>

        <h5 v-if="!processing">Exporting current page...</h5>
        <h5 v-if="processing">Awaiting export to be processed by server...</h5>
      </div>
    </div>
  </div>
</template>

<script>
  import {ReportsService} from '@/services';
  import html2canvas from 'html2canvas';
  import swal from 'sweetalert2';

  export default {
    data() {
      return {
        masterInstance: {},
        loggedUser: {},
        exporting: false,
        processing: false
      }
    },
    props: ['applicationId'],
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser'];
    },
    methods: {
      async doExport() {
        let vm = this;

        vm.exporting = true;
        let loader = vm.$loading.show();
        let images = [];
        let screenshot = await vm.takeScreenshot();
        images.push(screenshot);

        vm.processing = true;

        let response = await ReportsService.exportEvaluation({
          applicationId: vm.applicationId,
          images: images
        });

        vm.exporting = false;
        loader.hide();

        if (response.data.success === true) {
          let image_download = response.data.image_download;

          let html = 'Your evaluation report export is ready! <br/>' +
            'An email with export has been sent to: ' + vm.loggedUser.email + '<br/><br/>' +
            '<a class="btn btn-primary" target="_blank" href="' + image_download + '">Download Export</a>';

          await swal({
            title: this.$t('general.notification__success'),
            html: html,
            type: 'success',
            showConfirmButton: false
          });

          // force page-reload
          window.location.reload();
        }
      },
      async takeScreenshot() {
        let promise = new Promise((resolve, reject) => {
          setTimeout(() => resolve("done!"), 800)
        });
        await promise;

        return await html2canvas($('#evaluationGrid').get(0)).then(function (canvas) {
          let imageData = canvas.toDataURL('image/png');
          return imageData;
        });
      },
    }
  }
</script>